import React, { useState, useEffect } from "react";
import { useParams, useLocation, Link, useNavigate } from "react-router-dom";
import Toast from "react-bootstrap/Toast";
import "./UserEditPage.scss";

function UserEditPage() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const user = location.state?.user;

  const [username, setUsername] = useState(user?.username || "");
  const [name, setName] = useState(user?.name || "");
  const [organization, setOrganization] = useState(user?.organization || "");
  const [changePassword, setChangePassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    if (!user) {
      setToastMessage("Datele utilizatorului nu au fost furnizate.");
      setShowToast(true);

      setTimeout(() => {
        navigate("/dashboard");
      }, 3000);
    }
  }, [user, navigate]);

  const handleSave = () => {
    if (changePassword && password !== confirmPassword) {
      setToastMessage("Parolele nu corespund!");
      setShowToast(true);
      return;
    }

    setToastMessage("Parola schimbată cu succes!");
    setShowToast(true);
  };

  return (
    <div className="user-edit-container">
      <h2 className="page-title">Editaţi datele utilizatorului</h2>

      <div className="form-group">
        <label>Utilizator</label>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="input-field"
        />
      </div>

      <div className="form-group">
        <label>Nume</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="input-field"
        />
      </div>

      <div className="form-group">
        <label>Organizaţie</label>
        <input
          type="text"
          value={organization}
          onChange={(e) => setOrganization(e.target.value)}
          className="input-field"
        />
      </div>

      <div className="form-group checkbox-group">
        <label>
          <input
            type="checkbox"
            checked={changePassword}
            onChange={(e) => setChangePassword(e.target.checked)}
          />
          Schimba Parola
        </label>
      </div>

      {changePassword && (
        <>
          <div className="form-group">
            <label>Noua Parolă</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
            />
          </div>

          <div className="form-group">
            <label>Confirmaţi Noua Parolă</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="input-field"
            />
          </div>
        </>
      )}

      <button
        onClick={handleSave}
        className="save-button"
      >
        Save
      </button>

      <Link to="/dashboard">
        <button className="cancel-button">
          Cancel
        </button>
      </Link>

      <div className="toast-container">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={5000}
          autohide
          className="custom-toast"
          animation={false}
        >
          <Toast.Header>
            <span className="me-auto font-extrabold">Notification</span>
          </Toast.Header>
          <Toast.Body className="font-bold">{toastMessage}</Toast.Body>
        </Toast>
      </div>
    </div>
  );
}

export default UserEditPage;
